import { useEffect, useState } from 'react';

import { useGrowthBook } from '@growthbook/growthbook-react';

import { TEST_FEATURE_FLAG, WARRANTY_CARDS_FEATURE_FLAG } from './constants';

const INITIAL_STATE = {
    test: TEST_FEATURE_FLAG,
    warrantyCards: WARRANTY_CARDS_FEATURE_FLAG
};

const useFeatureFlags = () => {
    const growthbook = useGrowthBook();
    const [features, setFeatures] = useState(INITIAL_STATE);

    useEffect(() => {
        if (!growthbook?.ready) {
            return;
        }

        const rawFeatures = growthbook?.getFeatures();
        const mappedFeatures: Record<string, boolean> = {};

        for (const key of Object.keys(rawFeatures)) {
            mappedFeatures[key] = growthbook.evalFeature(key).on;
        }

        setFeatures(features => ({ ...features, ...mappedFeatures }));
    }, [growthbook]);

    const { test, warrantyCards } = features;

    return {
        TEST_FEATURE_FLAG: test,
        WARRANTY_CARDS_FEATURE_FLAG: warrantyCards
    };
};

export default useFeatureFlags;
